import { redirect } from "react-router-dom";
import { requireFeatureFlag, FeatureFlagsUnavailableError } from "src/app/featureFlags";
import { INDEX_ROUTES } from "src/app/constants";
import { serviceUnavailableResponse } from "../constants";

/**
 * Loader that gates the Form Studio route behind the enableFormStudio feature flag.
 *
 * Redirects to the admin index when the flag is disabled. Returns 503 when the
 * lookup failed, so an outage is not presented as the feature being turned off.
 */
export const loader = async () => {
  let isEnabled: boolean;
  try {
    isEnabled = await requireFeatureFlag("enableFormStudio");
  } catch (error) {
    if (error instanceof FeatureFlagsUnavailableError) {
      throw serviceUnavailableResponse(
        "We could not confirm whether Form Studio is available right now. " +
          "Please retry in a few moments."
      );
    }
    throw error;
  }

  return isEnabled ? null : redirect(INDEX_ROUTES.ADMIN);
};
